<template>
  <div>
    <table class="action-prop-table">
      <tr>
        <th>product</th>
        <td>{{pending.proto_id | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>amount</th>
        <td>{{pending.amount}}</td>
      </tr>
      <tr v-if="isLetterSpecified">
        <th>letter</th>
        <td>{{pending.text_config}}</td>
      </tr>
    </table>

    <p v-if="isPartOfMassPending">
      This pending is part of
      <mass-pending-link
        :massPendingId="pending.massPendingId"
        lable="mass pending"
      />.
    </p>
  </div>
</template>

<script>
import { isNumberSpecified } from '../util';
import { isStringSpecified } from '../util';

import MassPendingLink from './MassPendingLink.vue';

export default {
  name: 'PlayerPendingInfoRewardLetter',

  components: {
    MassPendingLink,
  },

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  computed: {
    isLetterSpecified() {
      return isStringSpecified(this.pending.text_config);
    },

    isPartOfMassPending() {
      return isNumberSpecified(this.pending.massPendingId);
    },
  },
}
</script>

<style scoped>
  .action-prop-table:not(:last-child) {
    margin-bottom: 0.5rem;
  }
</style>